import { useState } from "react";
import { toast } from "sonner";
import { CheckCircle2, Loader2, MessageCircle, MessageSquareText } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useContent } from "@/lib/content";
import { money } from "./ui";

const waNumber = (phone) => {
  const d = (phone || "").replace(/\D/g, "");
  return d.length === 10 ? `1${d}` : d;
};

export const readyText = (o, address) => {
  const first = (o.name || "").trim().split(/\s+/)[0];
  const due = !o.payment_method || o.payment_method === "in_store";
  const pay = due
    ? `Amount due: ${money(o.total)} — pay by card or cash when you collect.`
    : "It's already paid — just give us your order number.";
  return `Hi ${first}, your Wax Moi order ${o.number} is ready for pickup at Wax Moi Day Spa${address ? `, ${address}` : ""}. ${pay} See you soon!`;
};

export const ReadyActions = ({ o, onChange }) => {
  const c = useContent().data;
  const [busy, setBusy] = useState(false);
  const canReady = ["reserved", "paid"].includes(o.status);
  if (!canReady && o.status !== "ready") return null;
  const address = c?.contact?.address?.split(",")[0] || "";
  const text = readyText(o, address);
  const markReady = async () => {
    setBusy(true);
    try {
      await api.patch(`/admin/orders/${o.id}`, { status: "ready" });
      toast.success(`Marked ready — pickup email sent to ${o.email}`);
      onChange();
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  if (canReady) return (
    <div className="ready-bar" data-testid="order-ready-bar">
      <button type="button" className="btn gold" onClick={markReady} disabled={busy} data-testid="order-ready-button">
        {busy ? <Loader2 size={15} className="spin" /> : <CheckCircle2 size={15} />} Ready for pickup
      </button>
      <span className="muted-sm">Emails {o.name.split(" ")[0]} straight away, then lets you send a WhatsApp or text.</span>
    </div>
  );
  return (
    <div className="ready-bar is-ready" data-testid="order-ready-bar">
      <span className="ready-done"><CheckCircle2 size={15} /> Ready — email sent. Message {o.name.split(" ")[0]} too:</span>
      {o.phone && <>
        <a className="btn light ready-wa" href={`https://wa.me/${waNumber(o.phone)}?text=${encodeURIComponent(text)}`} target="_blank" rel="noopener noreferrer" data-testid="order-whatsapp-button"><MessageCircle size={15} /> WhatsApp</a>
        <a className="btn light" href={`sms:${o.phone.replace(/[^\d+]/g, "")}?&body=${encodeURIComponent(text)}`} data-testid="order-sms-button"><MessageSquareText size={15} /> Text</a>
      </>}
      <p className="ready-preview" data-testid="order-ready-message">{text}</p>
    </div>
  );
};
